<template>
  <div>
    <!-- Action Buttons -->
    <div v-if="(isAdmin || isManagement) && previewOrderList.length > 0" class="btn-group dropleft py-2 mx-1" role="group">
      <!-- WhatsApp Campaign Button -->
      <button class="btn btn-sm btn-success position-relative" @click="() => openCampaignModal('whatsappCampaign')" title="שלח הודעות וואטסאפ קבוצתיות">
        <span class="text-white">הודעות וואטסאפ קבוצתיות</span>
      </button>

      <!-- SMS Campaign Button -->
      <button class="btn btn-sm btn-primary position-relative mx-1" @click="() => openCampaignModal('smsCampaign')" title="שלח הודעות SMS קבוצתיות">
        <span class="text-white">הודעות SMS קבוצתיות</span>
      </button>

      <!-- Mail Campaign Button -->
      <button class="btn btn-sm btn-primary position-relative" @click="() => openCampaignModal('mailCampaign')" title="שלח הודעות Mail קבוצתיות">
        <span class="text-white">הודעות Mail קבוצתיות</span>
      </button>

      <!-- Status Update Button -->
      <button class="btn btn-sm btn-success position-relative mx-1" @click="() => openCampaignStatusesModal(true)" title="עדכן סטטוס קבוצתי">
        <span class="text-white">עדכון סטטוס קבוצתי</span>
      </button>
    </div>

    <!-- Campaign Messages Modal -->
    <CampaignMessages
      ref="campaignMessagesModel"
      id="campaignMessagesModel"
      :messages="campaignMessages"
      :rows="rows"
      :campaignKind="campaignKind"
      :previewOrderList="previewOrderList"
      :model="model"
      @alert="handleModalAlert"
    />

    <!-- Campaign Statuses Modal -->
    <CampaignStatuses 
      v-if="openStatusCampaign"
      ref="campaignStatusesModel"
      id="campaignStatusesModel"
      :statuses="campaignStatuses"
      :previewOrderList="previewOrderList"
      :tconfig="tconfig"
      :routhName="routeName"
      :component="component"
      :model="model"
      @alert="handleModalAlert"
    />
  </div>
</template>

<script>
import axios from '../axios'
import CampaignMessages from '@/views/Modal/campaignMessagesModel.vue'
import CampaignStatuses from '@/views/Modal/campaignStatusesModel.vue'

export default {
  name: 'CampaignActionsButtons',
  components: {
    CampaignMessages,
    CampaignStatuses
  },
  props: {
    previewOrderList: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      default: () => []
    },
    statuses: {
      type: [Array, Object],
      default: () => []
    },
    tconfig: {
      type: Object,
      default: () => ({})
    },
    routeName: {
      type: String,
      default: ''
    },
    component: {
      type: String,
      default: ''
    },
    model: {
      type: String,
      default: 'Order'
    }
  },
  data() {
    let statuses = this.statuses;
    console.log('statuses')
    console.log(this.statuses)
    console.log(statuses)
    // Convert Object to Array if needed
    if (statuses && typeof statuses === 'object' && !Array.isArray(statuses)) {
      statuses = Object.values(statuses);
    }
    console.log('statuses2')
    console.log(statuses)
    return {
      isAdmin: false,
      isManagement: false,
      campaignMessages: [],
      campaignStatuses: statuses || [],
      campaignKind: '',
      openStatusCampaign: false,
      dataTableReady: false
    }
  },
  watch: {
    statuses: {
      handler(newVal) {
        // Handle both Array and Object
        if (Array.isArray(newVal)) {
          this.campaignStatuses = newVal;
        } else if (newVal && typeof newVal === 'object') {
          // Convert Object to Array if needed
          this.campaignStatuses = Array.isArray(newVal) ? newVal : Object.values(newVal);
        }
      },
      deep: true
    }
  },
  created() {
     
    if (this.$store.getters.isAdmin) {
      this.isAdmin = this.$store.getters.isAdmin;
    }
    if (this.$store.getters.isManagement) {
      this.isManagement = this.$store.getters.isManagement;
    }
  },
  methods: {
    /**
     * Open campaign messages modal
     * @param {String} prefix - Type of campaign (whatsappCampaign, smsCampaign, mailCampaign)
     */
    openCampaignModal(prefix) {
      if (!prefix) {
        console.log('prefix not found');
        return;
      }

      this.dataTableReady = true;
      this.campaignKind = prefix;
      let that = this;

      axios.post(`${prefix}/all`)
        .then((res) => {
          that.dataTableReady = false;
          that.campaignMessages = res.data.data.rows;

          // Show modal
          setTimeout(() => {
            let modalRef = that.$refs.campaignMessagesModel;
            if (modalRef && modalRef.$el) {
              $(modalRef.$el).modal('show');
            } else {
              console.warn('campaignMessagesModel ref not found');
            }
          }, 100);
        })
        .catch((err) => {
          this.dataTableReady = false;
          const errorMsg = (err.response && err.response.data && err.response.data.status) || 'שגיאה בטעינת הודעות';
          this.$emit('alert', 'danger', errorMsg);
        });
    },

    /**
     * Open campaign statuses modal for bulk status update
     * @param {Boolean} action - Action indicator
     */
    openCampaignStatusesModal(action) {
      if (!action) {
        return;
      }

      this.openStatusCampaign = true;

      let that = this;
      setTimeout(() => {
        let modalRef = that.$refs.campaignStatusesModel;
        if (modalRef && modalRef.$el) {
          $(modalRef.$el).modal('show');
        } else {
          console.warn('campaignStatusesModel ref not found');
        }
      }, 100);
    },

    /**
     * Handle alert from modal child components
     */
    handleModalAlert(type, message) {
      this.$emit('alert', type, message);
    }
  }
}
</script>

<style scoped>
.btn-group {
  display: flex;
  gap: 0.25rem;
}

.btn {
  white-space: nowrap;
}
</style>

